export default "__VITE_ASSET__ohmd82$E__"